<template>
  <div class="animated fadeIn ordenes-subtrabajos">
    <b-row>
      <b-col cols="12">
        <!-- <b-card no-header> -->
        <b-card header= "Información de la Orden Interna">
          <b-form>
            <b-form-group
              label="Tipo de Artículo"
              label-for="articuloTipo"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarArticuloTipo">
                  <b-input-group-text>
                    <i class="fa fa-search"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="agregarArticuloTipo">
                  <b-input-group-text>
                    <i class="fa fa-plus"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="editarArticuloTipo"
                    v-if="articuloTipo">
                  <b-input-group-text>
                    <i class="fa fa-edit"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="articuloTipo"
                  :value="articuloTipoNombre"
                  :state="articuloTipoValido"
                  readonly
                  type="text"/>
                <b-form-invalid-feedback id="articuloTipoFeedback">
                  {{ articuloTipoInvalidoMsj }}
                </b-form-invalid-feedback>          
              </b-input-group>
            </b-form-group>

            <b-form-group
              label="Descripción"
              label-for="observaciones"
              :label-cols="labelCols"
              horizontal>
              <b-form-textarea
                id="observaciones"
                v-model="$v.observaciones.$model" 
                rows="5"
                max-rows="5"
                :state="observacionesValidas"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidasMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-row>
              <b-col cols="12" md="6">
                <app-moneda
                  label="Moneda"
                  :nombre="monedaNombre"
                  :labelCols="labelCols * 2"
                  :valido="monedaValida"
                  :lista="monedasList"
                  :msjInvalido="monedaInvalidaMsj"
                  @validate="validate"
                  @updated="monedaActualizada">
                </app-moneda>  

                <b-form-group
                  label="Cantidad"
                  label-for="cantidad"
                  :label-cols="labelCols * 2"
                  horizontal>
                  <b-form-input 
                    id="cantidad"
                    v-model.trim= "$v.cantidad.$model" 
                    :state="cantidadValida"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="cantidadFeedback">
                    {{ cantidadInvalidaMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Costo Unitario"
                  label-for="costo"
                  description="Costo Unitario IVA no incluido"
                  :labelCols="labelCols * 2">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-radio v-model="costoUnitario" 
                        name="costoUnitarioSelected" 
                        :value="Boolean(true)"
                        class="radio-group">
                      </b-form-radio>
                      <!-- <b-form-checkbox 
                          v-model="costoUnitario"
                          value= true
                          unchecked-value= false>
                      </b-form-checkbox> -->
                    </b-input-group-prepend>
                    <b-form-input 
                      id="costo" 
                      v-model.trim= "$v.costo.$model" 
                      type="text"
                      :readonly="costoDisabled"
                      :state="costoValido"
                      @blur.native="validate"
                      @input.native="calcularCostoTotal">
                    </b-form-input>
                  </b-input-group>
                  <b-form-invalid-feedback id="costoFeedback">
                    {{ costoInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Costo Total"
                  label-for="costoTotal"
                  description="Costo Total IVA no incluido"
                  :labelCols="labelCols * 2">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-radio v-model="costoUnitario" 
                        name="costoTotalSelected" 
                        :value="Boolean(false)"
                        class="radio-group">
                      </b-form-radio>
                      <!-- <b-form-checkbox 
                          v-model="costoTotal"
                          value= true
                          unchecked-value= false>
                      </b-form-checkbox> -->
                    </b-input-group-prepend>
                    <b-form-input 
                      id="costoTotal" 
                      v-model.trim= "$v.costoTotal.$model" 
                      type="text"
                      :readonly="costoTotalDisabled"
                      :state="costoTotalValido"
                      @blur.native="validate"
                      @input.native="calcularCostoUnitario">
                    </b-form-input>
                  </b-input-group>
                  <b-form-invalid-feedback id="costoTotalFeedback">
                    {{ costoTotalInvalidoMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>

              <b-col cols="12" md="6">
                <b-form-group
                  label="Dias Producción"
                  label-for="diasProduccion"
                  :label-cols="labelCols * 2"
                  horizontal
                  description="Dias hábiles para producción (sólo números)">
                  <b-form-input 
                    id="diasProduccion"
                    v-model.trim="$v.diasProduccion.$model" 
                    :state="diasProduccionValidos"
                    type="text"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="diasProduccionFeedback">
                    {{ diasProduccionInvalidosMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-col>
            </b-row>

            <br>
            <hr>
            <br>

            <b-form-group
              label="Fecha Comp."
              label-for="fechaComprobante"
              :label-cols="labelCols"
              description="Fecha de la orden al proveedor"
              horizontal>
              <b-form-input 
                id="fechaComprobante" 
                v-model="fechaComprobante" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Proveedor"
              label-for="proveedor"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarProveedor">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !proveedor,
                                  'fa fa-remove': proveedor  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="agregarProveedor">
                  <b-input-group-text>
                    <i class="fa fa-plus"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="proveedor"
                  :value="proveedorNombre"
                  :state="proveedorValido"
                  readonly
                  type="text"/>
                <b-form-invalid-feedback id="proveedorFeedback">
                  {{ proveedorInvalidoMsj }}
                </b-form-invalid-feedback>          
              </b-input-group>
            </b-form-group>

            <br>
            <b-form-group
              label="Condiciones de Pago"
              label-for="formasPago"
              :label-cols="labelCols"
              horizontal>

              <div class="table-button" @click.prevent="agregarFormaPago">
                  <i class="fa fa-plus" aria-hidden="true"></i>
              </div>
              <b-table hover
                  responsive="sm" 
                  class="registro"
                  :busy="tableBusy"
                  :items="formasPago" 
                  :fields="formasPagoFields">
                <div slot="table-busy" class="text-center">
                  <b-spinner class="table-spinner" label="Spinning" />
                </div>              
                <template v-slot:cell(porcentaje)="data">
                  {{ data.item.porcentaje | numero(2, true) }}
                </template>
                <template v-slot:cell(opciones)="data">
                  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                    <template slot="button-content">
                      <i class="fa fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item @click.stop="borrarFormaPago(data.item)">
                      <i class="fa fa-remove"></i>Eliminar</b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </b-form-group>
            <br>

            <b-form-group
              label="Fecha Entrega"
              label-for="fechaEntrega"
              :label-cols="labelCols"
              description="Fecha de entrega pactada"
              horizontal>
              <b-form-input 
                id="fechaEntrega" 
                v-model="fechaEntrega" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Dirección de Entrega"
              label-for="direccionEntrega"
              :label-cols="labelCols"
              horizontal
              description="Dirección de entrega">
              <b-form-input 
                id="direccionEntrega"
                v-model.trim= "$v.direccionEntrega.$model" 
                :state="direccionEntregaValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="direccionEntregaFeedback">
                {{ direccionEntregaInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goOrdenesProveedores">
    </app-a-b-m-button>  

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>

    <confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </confirm>

    <b-modal ref="searchArticuloTipoModal"
        title="Seleccionar Tipo de Artículo"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-articulo-tipo
        @articuloTipoSeleccionado="articuloTipoSeleccionado">
      </app-search-articulo-tipo>  
    </b-modal>

    <b-modal ref="articuloTipoModal"
        title="Datos del Tipo de Artículo"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-articulo-tipo
        :modal="true"
        :articuloTipoId="articuloTipoSeleccionadoId"
        @updateArticuloTipo="updateArticuloTipo"
        @closeArticuloTipo="closeArticuloTipo">
      </app-articulo-tipo>  
    </b-modal>

    <b-modal ref="proveedorModal"
        title="Alta de Proveedores"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-proveedor
        @updateProveedor="updateProveedor"
        @closeProveedor="closeProveedor">
      </app-proveedor>  
    </b-modal>

    <b-modal ref="searchProveedorModal"
        title="Seleccionar Proveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-proveedor
        @proveedorSeleccionado="proveedorSeleccionado">
      </app-search-proveedor>  
    </b-modal>

    <b-modal ref="formaPagoModal" 
        title="Seleccionar Forma de Pago"
        modal-class="modalABM"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-forma-pago
        :noRequiereContrato="noRequiereContrato"
        :tieneContrato="tieneContrato"
        :contratoPagare="contratoPagare"
        @updateFormaPago="updateFormaPago"
        @closeFormaPago="closeFormaPago">
      </app-forma-pago>  
    </b-modal>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import SearchArticuloTipo from '../articulosTipos/SearchList.vue';
import ArticuloTipo from '../articulosTipos/ABM.vue';
import SearchProveedor from '../proveedores/SearchList.vue';
import Proveedor from '../proveedores/Alta.vue';
// import OrdenProveedor from '../ordenesproveedores/ABM.vue';
import FormaPago from '../ordenesproveedores/FormaPago.vue';
import Moneda from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { required, numeric, decimal, minValue, maxLength, email } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'ordenTrabajoInterna/getField',
  mutationType: 'ordenTrabajoInterna/updateField',
});

export default {
  name: 'OrdenTrabajoInternaABM',
  components: {
    appABMButton: ABMButtons,
    appSearchArticuloTipo: SearchArticuloTipo,
    appArticuloTipo: ArticuloTipo,
    appSearchProveedor: SearchProveedor,
    appProveedor: Proveedor,
    // appOrdenProveedor: OrdenProveedor,
    appFormaPago: FormaPago,
    appMoneda: Moneda,
    Mensaje,
    Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data () {
    return {
      noValidar: true,
      articuloTipoValido: null,
      articuloTipoInvalidoMsj: '',
      proveedorValido: null,
      proveedorInvalidoMsj: '',
      monedaValida: null,
      monedaInvalidaMsj: '',
      cantidadValida: null,
      cantidadInvalidaMsj: '',
      costoValido: null,
      costoInvalidoMsj: '',
      costoTotalValido: null,
      costoTotalInvalidoMsj: '',
      diasProduccionValidos: null,
      diasProduccionInvalidosMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',
      direccionEntregaValida: null,
      direccionEntregaInvalidaMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      formasPagoFields: [
        { key: 'formaPago' },
        { 
          key: 'porcentaje',
          class: 'text-right'
        },
        { key: 'condiciones' },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      articuloTipoSeleccionadoId: 0,
      monedas: [],
      monedasList: [],

      noValidar: true,
      tableBusy: false,
      inicializandoMonedas: false,

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      // 'id',
      'articuloTipoId',
      'articuloTipo',
      'articuloTipoNombre',
      'proveedorId',
      'proveedor',
      'proveedorNombre',
      'monedaId',
      'moneda',
      'monedaNombre',
      'cantidad',
      'costo',
      'costoTotal',
      'costoUnitario',
      'diasProduccion',
      'observaciones',

      'fechaComprobante',
      'fechaEntrega',
      'formasPago',
      'direccionEntrega',

      'noRequiereContrato',
      'tieneContrato',
      'contratoPagare'

    ]),
    costoDisabled() {
      return !this.costoUnitario;
    },
    costoTotalDisabled() {
      return Boolean(this.costoUnitario);
    },
  },  
  created() {
    // let ordenTrabajoInternaId = 0;
    // if (this.$route.params){
    //   if (this.$route.params.id){
    //     ordenTrabajoInternaId = this.$route.params.id;
    //   }
    // }

    this.showSpinner();
    // this.$store.dispatch('ordentrabajointerna/inicializar', ordenTrabajoInternaId)
    this.$store.dispatch('ordenTrabajoInterna/inicializar')
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      this.inicializandoMonedas = true;
      this.$store.dispatch('monedas/getList')
        .then(() => {
          this.monedas = this.$store.getters['monedas/list'];
          this.monedasList = this.$store.getters['monedas/selectList'];
          this.inicializandoMonedas = false;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de monedas.'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'cantidad' || validarTodos) {
        if (this.$v.cantidad.$error) {
          this.cantidadValida = false;
          if (!this.$v.cantidad.decimal || !this.$v.cantidad.minValue) {
            this.cantidadInvalidaMsj = 'La cantidad debe ser un valor numérico positivo';
          }
        } else {
          this.cantidadValida = null;
          this.cantidadInvalidaMsj = '';
        }
      }

      if (this.costoUnitario) {
        if (campo == 'costo' || validarTodos) {
          if (this.$v.costo.$error) {
            this.costoValido = false;
            if (!this.$v.costo.decimal || !this.$v.costo.minValue) {
              this.costoInvalidoMsj = 'El costo ingresado no es válido';
            }
          } else {
            this.costoValido = null;
            this.costoInvalidoMsj = '';
          }
        }
      } else {
        if (campo == 'costoTotal' || validarTodos) {
          if (this.$v.costoTotal.$error) {
            this.costoTotalValido = false;
            if (!this.$v.costoTotal.decimal || !this.$v.costoTotal.minValue) {
              this.costoTotalInvalidoMsj = 'El costo total ingresado no es válido';
            }
          } else {
            this.costoTotalValido = null;
            this.costoTotalInvalidoMsj = '';
          }
        }
      }

      if (campo == 'diasProduccion' || validarTodos) {
        if (this.$v.diasProduccion.$error) {
          this.diasProduccionValidos = false;
          if (!this.$v.diasProduccion.numeric || !this.$v.diasProduccion.minValue) {
            this.diasProduccionInvalidosMsj = 'La cantidad de días de producción debe ser un valor numérico positivo';
          }
        } else {
          this.diasProduccionValidops = null;
          this.diasProduccionInvalidosMsj = '';
        }
      }

      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'La descripción solo puede contener hasta 5000 caracteres';
          }
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }

      if (campo == "direccionEntrega" || validarTodos) {
        if (this.$v.direccionEntrega.$error) {
          this.direccionEntregaValida = false;
          if (!this.$v.direccionEntrega.maxLength) {
            this.direccionEntregaInvalidaMsj = 'La direccion de entrega sólo pueden contener hasta 150 caracteres';
          }
        } else {
          this.direccionEntregaValida = null;
          this.direccionEntregaInvalidaMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch()

      let save = Boolean(true);
      //console.log(this.articuloId);

      let articuloTipoError = true;
      if (this.articuloTipoId) {
        if (this.articuloTipoId != 0) {
          articuloTipoError = false;
        }
      }
      if (articuloTipoError) {
        save = Boolean(false);
        this.articuloTipoValido = false;
        this.articuloTipoInvalidoMsj = 'Debe seleccionar el tipo de artículo correspondiente.';
      }

      let proveedorError = true;
      if (this.proveedorId) {
        if (this.proveedorId != 0) {
          proveedorError = false;
        }
      }
      if (proveedorError) {
        save = Boolean(false);
        this.proveedorValido = false;
        this.proveedorInvalidoMsj = 'Debe seleccionar el proveedor correspondiente.';
      }

      let errorMoneda = true;
      if (this.moneda) {
        if (this.moneda.id) {
          if (this.moneda.id != 0) {
            errorMoneda = false;
          }
        }
      }
      if (errorMoneda) {
        this.monedaValida = false;
        this.monedaInvalidaMsj = 'Debe seleccionar la moneda correspondiente.';
        save = false;
      }

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          this.showSpinner();
          this.$store.dispatch('ordenTrabajoInterna/save')
            .then(() => this.showModalMsj('La información se registró con éxito', this.goOrdenesProveedores, this.goOrdenesProveedores, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        }
      }
    },

    goOrdenesProveedores() {
      this.$router.push({ name: 'OrdenesProveedores' });
    },
    
    seleccionarArticuloTipo() {
      this.$refs.searchArticuloTipoModal.show();
    },
    articuloTipoSeleccionado(item) {
      this.$refs.searchArticuloTipoModal.hide();
      this.$store.dispatch('ordenTrabajoInterna/setArticuloTipo', item.id)
        .catch(error => this.showErrorMsj(error));
    },
    seleccionarProveedor() {
      if (this.proveedorId != 0) {
        this.$store.dispatch('ordenTrabajoInterna/setProveedor');
      } else {
        this.$refs.searchProveedorModal.show();
      }
    },
    proveedorSeleccionado(item) {
      this.$refs.searchProveedorModal.hide();
      this.$store.dispatch('ordenTrabajoInterna/setProveedor', item)
        .catch(error => this.showErrorMsj(error));
    },
    monedaActualizada(monedaNombre) {
      if (!this.inicializandoMonedas) {
        this.monedaNombre = monedaNombre;

        if (this.monedaNombre) {
          let moneda = this.getSelected(this.monedas, this.monedaNombre);
          this.$store.dispatch('ordenTrabajoInterna/setMoneda', moneda)
            .catch(error => this.showErrorMsj(error))

          this.monedaValida = null;
          this.monedaInvalidaMsj = '';
        }
      }
    },
    agregarArticuloTipo() {
      this.articuloTipoSeleccionadoId = 0;
      this.$refs.articuloTipoModal.show();
    },
    editarArticuloTipo() {
      this.articuloTipoSeleccionadoId = this.articuloTipoId;
      this.$refs.articuloTipoModal.show();
    },
    updateArticuloTipo(articuloTipo) {
      this.$refs.articuloTipoModal.hide();
      this.$store.dispatch('ordenTrabajoInterna/setArticuloTipo', articuloTipo.id)
        .catch(error => this.showErrorMsj(error));
    },
    closeArticuloTipo() {
      this.$refs.articuloTipoModal.hide();
    },
    agregarProveedor() {
      this.$refs.proveedorModal.show();
    },
    updateProveedor(proveedor) {
      let proveedorDatos = {
        id: proveedor.id,
        nombre: proveedor.nombreComercial.trim()
      }

      this.$refs.proveedorModal.hide();
      this.$store.dispatch('ordenTrabajoInterna/setProveedor', proveedorDatos)
        .catch(error => this.showErrorMsj(error));
    },
    closeProveedor() {
      this.$refs.proveedorModal.hide();
    },
    calcularCostoUnitario() {
      this.$store.dispatch('ordenTrabajoInterna/calcularCostoUnitario');
    },
    calcularCostoTotal() {
      this.$store.dispatch('ordenTrabajoInterna/calcularCostoTotal');
    },
    
    agregarFormaPago() {
      this.$store.dispatch('ordenproveedorformapago/inicializar')
        .then(() => {
          this.$refs.formaPagoModal.show();
        })
    },
    borrarFormaPago(item) {
      this.showSpinner();
      this.$store.dispatch('ordenTrabajoInterna/removeFormaPago', item)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    updateFormaPago(ordenProveedorFormaPago) {
      this.$refs.formaPagoModal.hide();

      this.$store.dispatch('ordenTrabajoInterna/addFormaPago', ordenProveedorFormaPago)
        .catch(error => this.showErrorMsj(error))
    },
    closeFormaPago() {
      this.$refs.formaPagoModal.hide();
    }
  },
  validations: {
    cantidad: {
      required,
      decimal,
      minValue: minValue(0)
    },
    costo: {
      decimal,
      minValue: minValue(0)
    },
    costoTotal: {
      decimal,
      minValue: minValue(0)
    },
    observaciones: {
      maxLength: maxLength(5000)
    },
    diasProduccion: {
      numeric,
      minValue: minValue(0)
    },
    direccionEntrega: {
      maxLength: maxLength(150)
    },
  },
  watch: {
  }  
}
</script>

<style>
</style>
